module.exports = __webpack_public_path__ + "img/circle-bookmark.381cc211.svg";